import { ProjectRenderer } from '../ProjectRenderer';
import { CollisionHandler } from '../utils/CollisionHandler';
import { MathUtils } from 'three';
import { TransformControls, TransformControlsMode } from './TransformControls';
import { CollidableObject } from '../objects/CollidableObject';
import { RendererMode } from '../types';
import RENDERER_CONFIG from '@/configs/rendererConfig';
import APP_CONFIG from '@/configs/appConfig';

export class TransformController {
	private controls: TransformControls;
	tranformControlsHovered = false;
	collisionHandler: CollisionHandler;
	selectedModule: CollidableObject | null = null;

	constructor(private renderer: ProjectRenderer) {
		this.controls = new TransformControls(
			this.renderer.cameraController.orthographicCamera,
			this,
			this.renderer.renderer.domElement,
			renderer.isTouchDevice
		);

		this.setMode(APP_CONFIG.DEFAULT_TRANSFORM_MODE);

		this.controls.setRotationSnap(
			MathUtils.degToRad(RENDERER_CONFIG.TRANSFORM_CONTROLS.ROTATION_SNAP)
		);

		this.renderer.scene.add(this.controls.getHelper());

		this.addEventListeners();

		this.collisionHandler = new CollisionHandler(this.renderer);
	}

	private addEventListeners() {
		this.controls.addEventListener('mouseDown', (event) => {
			this.renderer.cameraController.orthographicControls.enabled = false;
			this.renderer.inputHandler.enabled = false;
		});

		this.controls.addEventListener('mouseUp', (event) => {
			this.renderer.cameraController.orthographicControls.enabled = true;
			this.renderer.inputHandler.enabled = true;
			this.renderer.inputHandler.clearLongPressTimeout();
		});

		this.controls.addEventListener('objectChange', (event) => {
			if (!this.selectedModule) return;

			this.selectedModule.updateBoundingBox();
			this.collisionHandler.checkCollisions(this.selectedModule);
		});

		this.controls.addEventListener('dragging-changed', (event) => {});
	}

	setAvailability() {
		this.controls.detach();

		this.controls.enabled =
			this.renderer.isTouchDevice ||
			this.renderer.mode === RendererMode.MODULES;
	}

	setMode(mode: TransformControlsMode) {
		this.controls.setMode(mode);

		this.controls.showX = mode === 'translate';
		this.controls.showY = mode !== 'translate';
		this.controls.showZ = mode === 'translate';
	}

	setToModule(collidableModule: CollidableObject) {
		this.controls.attach(collidableModule.group);
	}

	detach() {
		this.controls.detach();
		this.tranformControlsHovered = false;
	}
}
